import _ from 'lodash';

import { handleErrors } from '../../actions/ErrorActions';
import * as attachmentsApi from '../../api/attachments';
import { normalizeAttachmentData } from '../utils/actions/file-upload.actions.utils';
import { getDataPath, getEntityPrimaryKey } from '../utils/form-manager.utils';
import { generateRowId } from '../utils/runtime.utils';

export const UPLOAD_ATTACHMENTS_SUCCESS = 'UPLOAD_ATTACHMENTS_SUCCESS';

export function uploadAttachments(file, entityName, formKey, gridId, parentData) {
  return async (dispatch, getState) => {
    try {
      const apiData = await attachmentsApi.uploadAttachment(file);

      if (apiData.hasError) {
        dispatch(handleErrors(apiData.errors, { isTopBanner: apiData.isTopBanner }));
        return;
      }

      const { entityDefinition, data } = getState().formDesigner[formKey];
      const { formInfo } = data;
      const path = getDataPath(entityName, [0], entityDefinition);
      const allRows = _.get(data.entityDataStore?.entityData, path.slice(0, -1), []);
      const reversedRows = [...allRows].reverse();
      const rowId = generateRowId(reversedRows, 'BAH_ID');

      const entityType = Object.keys(entityDefinition)[0];
      const entityData = _.get(data, ['entityDataStore', 'entityData', entityType]);
      const primaryKeyColumn = getEntityPrimaryKey(entityDefinition, entityType);
      const PARENT_PK_ID = entityData[primaryKeyColumn];

      const result = normalizeAttachmentData({
        uploadData: apiData.Result,
        PARENT_PK_ID,
        formInfo,
        rowId,
        gridId,
        parentData,
      });

      dispatch({
        type: UPLOAD_ATTACHMENTS_SUCCESS,
        formKey,
        payload: {
          entityName,
          result,
        },
      });

      return Promise.resolve(apiData.Result);
    } catch (error) {
      dispatch(handleErrors(error));

      return Promise.reject(error);
    }
  };
}
